import React from "react";
import { PRIORITY_CODES, codeClasses } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function TriageCodePanel({ suggested, assigned, onAssign, reason, onReason }) {
  const modified = assigned && suggested && assigned !== suggested;
  return (
    <div className="bg-white border border-slate-200 rounded-md p-6">
      <h3 className="font-heading text-lg font-semibold mb-4">Codice di priorità</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500 mb-2">Codice suggerito dal sistema</div>
          <div data-testid="suggested-code"
               className={`chip-code text-base px-4 py-3 border ${suggested ? codeClasses(suggested) : "bg-slate-100 text-slate-500 border-slate-200"}`}>
            {suggested ? suggested.toUpperCase() : "—"}
          </div>
          <p className="text-xs text-slate-500 mt-2">Basato esclusivamente sui discriminatori selezionati.</p>
        </div>
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500 mb-2">Conferma / modifica</div>
          <div className="flex flex-wrap gap-2">
            {PRIORITY_CODES.map((c) => (
              <button
                key={c.code}
                type="button"
                data-testid={`assign-${c.code}`}
                onClick={() => onAssign(c.code)}
                className={`chip-code text-base px-4 py-3 border transition-colors ${
                  assigned === c.code ? c.classes + " ring-2 ring-offset-2 ring-slate-900" : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
                }`}
              >{c.label}</button>
            ))}
          </div>
        </div>
      </div>
      {modified && (
        <div className="mt-4">
          <Label className="text-[10px] font-semibold uppercase tracking-[0.15em] text-slate-500">
            Motivazione modifica rispetto al suggerimento
          </Label>
          <Input
            data-testid="reason-input"
            value={reason || ""}
            onChange={(e) => onReason(e.target.value)}
            placeholder="Descrivere brevemente il motivo clinico"
            className="mt-2"
          />
        </div>
      )}
    </div>
  );
}
